/**  */

// eslint-disable-next-line
import React from 'react';
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';

import { themeVars } from '../../config/styles';

// Components
import HeroContent from './HeroContent';
import HeroImageSlider from './HeroImageSlider';
import Nav from '../Header/Nav';

const HeroHeader = ({
  backgroundImage,
  heroTitle,
  handleMenuOpen,
  imageSlider,
  imageSliderImages,
  parentPage,
}) => {
  const cssWrapper = css`
    height: 50vh;
    min-height: 500px;
    position: relative;
    margin: 0;
  `;

  const cssContentWrapper = css`
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 100%;
    background: rgb(0, 66, 98);
    background: linear-gradient(225deg, rgba(20,37,94,0) 0%, #14255E 100%);
  `;

  const cssImage = css`
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: ${themeVars.root.primary};
    ${backgroundImage && `background-image: url(${backgroundImage.sizes.hero_bg}) `};
    background-attachment: scroll;
  `;

  return (
    <>
      <header css={cssWrapper}>
        <div css={cssImage}>
          <div css={cssContentWrapper}>
            <Nav handleMenuOpen={handleMenuOpen} />

            <HeroContent parentPage={parentPage} title={heroTitle} />
          </div>
        </div>
      </header>

      {imageSlider && (
        <HeroImageSlider imageSlider={imageSlider} imageSliderImages={imageSliderImages} />
      )}
    </>
  );
};

HeroHeader.defaultProps = {
  imageSlider: null,
  imageSliderImages: null,
  parentPage: null,
  heroTitle: '',
  backgroundImage: {
    sizes: {
      hero_bg: null,
    },
  },
};

HeroHeader.propTypes = {
  backgroundImage: PropTypes.shape({
    sizes: PropTypes.shape({
      hero_bg: PropTypes.string,
    }),
  }),
  handleMenuOpen: PropTypes.func.isRequired,
  heroTitle: PropTypes.string,
  imageSlider: PropTypes.bool,
  imageSliderImages: PropTypes.arrayOf(PropTypes.shape()),
  parentPage: PropTypes.string,
};

export default HeroHeader;
